module.exports = __webpack_public_path__ + "static/img/logo-04.65d571c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/portfolio/online-acc-registration/logo-04.png
// module id = 56k/
// module chunks = 1